import { render, staticRenderFns } from "./userPay.vue?vue&type=template&id=7024d00d&scoped=true&"
import script from "./userPay.vue?vue&type=script&lang=js&"
export * from "./userPay.vue?vue&type=script&lang=js&"
import style0 from "./userPay.vue?vue&type=style&index=0&id=7024d00d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024d00d",
  null
  
)

export default component.exports